<template>
    <div class="land-news">
        <div class="container">
            <div class="land-section-title" v-if="salesCardPage != null">
                <h2>{{salesCardPage.land_site_section_titles.news}}</h2>
            </div>
            <div class="land-news-items">
                <div class="item" v-for="(item, index) in salesCard.project_land_site.news_items" :key="index">
                    <div class="item-title">
                        <h3>{{item.title}}</h3>
                    </div>
                    <div class="item-ready">
                        <div class="ready-scale">
                            <div class="default-line"></div>
                            <div class="ready-line" :style="'width:' + item.ready_number + '%'"></div>
                        </div>
                        <div class="item-ready-number" :style="'left:' + item.ready_number + '%'">
                            <h4>
                                {{item.ready_number}}
                            </h4>
                            <span>%</span>
                        </div>
                    </div>
                    <a href="#" class="land-news-link" :disabled="item.btn_activity == false"  @click.prevent="openNewsModalInit(index)">
                        <span v-if="lang != 'kz/'">Подробнее</span>
                        <span v-else>Толығырақ</span>
                    </a>
                </div>
            </div>
            <!-- Новостная модалка -->
            <modal name="news-modal" 
                @before-close="beforeNewsModalClose" 
                @closed="newsModalClosed" 
                :transition="transitionName" 
                :width="modalWidth" 
                :height="modalHeight" 
                :scrollable="modalScrollable"                 
                id="news-modal">
                <newsModal :config="[{loading: loading, notVisible: notVisible, visible: visible, valueOption: valueOption}]"></newsModal>
            </modal>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import newsModal from '@/components/sales-land-partials/land-news-modal.vue'
    export default {
        name: 'sale-land-news',
        components: {
            newsModal,
        },
        data () {
            return {
                lang: window.GlobalLang,
                get: [
                    {
                        link: window.host + '_one'
                    },
                    {
                        link: window.host + '_two'
                    },
                    {
                        link: window.host + '_three'
                    },
                    {
                        link: window.host + '_four'
                    },
                    {
                        link: window.host + '_five'
                    },
                ],
                getOrioniii: [
                    {
                        link: 'orion_iii_one'
                    }
                ],
                getKohOta: [
                    {
                        link: 'news_part_one'
                    },
                    {
                        link: 'news_part_two'
                    },
                    {
                        link: 'news_part_three'
                    },
                ],
                getSoho2: [
                    {
                        link: 'soho_one'
                    },
                    {
                        link: 'soho_two'
                    },
                    {
                        link: 'soho_three'
                    },
                ],
                ready: [
                    {
                        number: 0
                    },
                    {
                        number: 0
                    },
                    {
                        number: 0
                    }
                ],
                valueOption: 0,
                visible: false,
                activity: [],
                loading: true,
                notVisible: true,
                animate: false,
                modalWidth: 1000,
                modalHeight: 'auto',
                modalScrollable: false,
                transitionName: 'pop-out',
                projectHost: window.host,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
            openNewsModalInit(index) {
                var _self = this;
                var url;

                if (this.projectHost == 'orion-3') {
                    // console.log(url, 'asdasda')
                    url = window.newsUrl + window.GlobalLang + window.JsonUrl + this.getOrioniii[index].link;
                } else if (this.projectHost == 'soho2') {
                    url = window.newsUrl + window.GlobalLang + window.JsonUrl + this.getSoho2[index].link;
                } else  {
                    url = window.newsUrl + window.GlobalLang + window.JsonUrl + this.get[index].link;
                }
                // console.log(url)
                axios.get(url)
                .then((response) => {
                    // console.log(url, response)
                    if(response)
                    setTimeout(function(){
                        var select = $('#select-month'),
                            selectParent = $('.news-modal-info-selection-item');
                        select.selectric();
                        select.selectric({
                            onChange: function() {
                                _self.valueOption = $(this).val();
                            },
                            onOpen: function() {
                                selectParent.addClass('open');
                            },
                            onClose: function() {
                                selectParent.removeClass('open');  
                            }
                        });
                    },500);
                    setTimeout(function(){
                        _self.notVisible = false;
                        _self.loading = false;
                    },800);
                    this.visible = true;
                    this.$store.dispatch('clearNewsData');
                    var i;
                    for (i = 0; i < response.data.length; i++) {
                        this.$store.commit('newsData', response.data[i].acf);
                    }
                });
                this.$modal.show('news-modal');
                document.getElementById('header').classList.add('notvisibleSalesLand');
                document.getElementById('landNav').classList.add('notvisibleSalesLand');
                if (this.projectHost != 'kohota') {
                    document.getElementById('banerTopHorizont').classList.add('notvisibleSalesLand');
                }
                document.getElementById('footer').classList.add('notvisibleSalesLand');
                // document.getElementById('secret-btns').classList.remove('fadeIn');
            },
            beforeNewsModalClose() {
                this.notVisible = true;
            },
            newsModalClosed() {
                this.loading = true;
                this.valueOption = 0;
                document.getElementById('header').classList.remove('notvisibleSalesLand');
                document.getElementById('landNav').classList.remove('notvisibleSalesLand');
                if (this.projectHost != 'kohota') { 
                    document.getElementById('banerTopHorizont').classList.remove('notvisibleSalesLand');
                }
                document.getElementById('footer').classList.remove('notvisibleSalesLand');
                // document.getElementById('secret-btns').classList.add('fadeIn');
            },
            settingsNewsModal() {
				var _self = this;
				if ($(window).width() > 1024) {
					_self.modalWidth = 1000;
					_self.modalHeight = 'auto';
					_self.transitionName = 'pop-out';
				} else {
					_self.modalWidth = 100;
					_self.modalHeight = 'auto';
					_self.modalScroll = true;
					_self.transitionName = 'fade-enter';
				}
			},
			handleResize() {
                var _self = this;
                if (window.innerWidth >= 1024) {
                    _self.modalWidth = 1000;
					_self.modalHeight = 'auto';
                } else {
					_self.modalScroll = true;
					_self.modalHeight = 'auto';
				}
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.settingsNewsModal();
            this.checkResize();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-news.scss';
     @import '@/styles/respond/sales/sales-land-partials/land-news-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>